import { useNavigate } from 'react-router-dom';

import InputField from 'components/fields/InputField';
import useForm from 'hooks/useForm';
import { useAlert } from 'context/alertContext';
import UseApi from 'hooks/useApi';

export default function SignIn() {
  const navigate = useNavigate();
  const { setSuccessMessage } = useAlert();
  const { postApi } = UseApi();

  const login = async () => {
    const res = await postApi(`admin/login`, values);
    if (res?.data.message) {
      resetForm();
    }
    const { accessToken, refreshToken, admin } = res.data.data;
    if (admin) {
      localStorage.setItem('admin', JSON.stringify(admin));
    }
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
    }
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken);
    }
    if (accessToken && refreshToken) {
      setSuccessMessage('Logged in successfully');
      navigate('/admin');
    }
  };

  const { values, handleChange, resetForm, handleSubmit } = useForm(
    {
      username: '',
      password: '',
    },
    login,
  );
  const { username, password } = values;

  return (
    <div className="flex h-[100vh] w-[100vw] items-center justify-center bg-gradient-to-r from-brand-100 to-brand-400">
      {/* <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start"> */}
      {/* Sign in section */}
      <div className="mx-2 w-full max-w-[90vw] max-w-full flex-col items-center rounded-xl bg-white px-[30px] pb-[60px] xl:max-w-[620px] xl:px-[100px]">
        <img src="/BaydaarLogo.png" className="mx-auto my-4 w-[190px] " />
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your username and password to sign in!
        </p>
        {/* Username */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Username*"
          placeholder="username"
          id="username"
          type="text"
          value={username}
          onChange={handleChange}
          name="username"
        />

        {/* Password */}
        <InputField
          variant="auth"
          extra="mb-3"
          label="Password*"
          placeholder="****"
          id="password"
          type="password"
          value={password}
          onChange={handleChange}
          name="password"
        />
        <button
          onClick={handleSubmit}
          className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
        >
          Sign In
        </button>
      </div>
    </div>
    // </div>
  );
}
